import { useSelector } from 'react-redux'
import type { RootState } from '../store'

/** Does this company run Box Truck? The answer is the server's, stored when the operator check returns. */
export const useIsBoxTruckCompany = (): boolean => useSelector((state: RootState) => state.boxTruckLoads?.boxTruckCompany) === true
